import React from 'react';
import { CheckboxWithLabel } from '@packages/shared';
import { useIntl } from 'react-intl';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { paymentPauseMessages } from './messages';

export interface PaymentPauseProps {
  /**
   * is payment pause enabled or not
   */
  checked: boolean;
  /**
   * a handler function which will be executed if the user checks or unchecks the checkbox
   */
  checkHandler: (checked: boolean) => void;
}

/**
 * payment pause atom
 *
 * displayes the payment pause checkbox
 *
 * */
export const PaymentPause = ({ checked, checkHandler }: PaymentPauseProps) => {
  const { formatMessage } = useIntl();
  const {
    company: { name },
  } = useConfig();

  const label = formatMessage(paymentPauseMessages.Label, {
    hint: (chunks: React.ReactNode) => <span>{chunks}</span>,
    brand: name,
  });

  return (
    <CheckboxWithLabel
      checkboxProps={{
        checked,
        onChange: (event) => checkHandler(event.target.checked),
        clickTrackingProps: {
          category: 'Ratenrechner',
          detail: 'Valuta',
          label: 'Kredit-Promo',
        },
      }}
      label={label}
    />
  );
};
